// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import type { Location, Match, RouterHistory } from 'react-router-dom'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import HesburgerPage from './HesburgerPage/HesburgerPage'
import KitchenPage from './KitchenPage/KitchenPage'
import ManagerPage from './ManagerPage/ManagerPage'
import MarketPage from './MarketPage/MarketPage'
import RestaurantPage from './RestaurantPage/RestaurantPage'
import css from './monthlyInfoRoot.css'
const TABS = {
  MANAGER: 'liikennemyymalapaallikko',
  RESTAURANT: 'ravintola',
  KITCHEN: 'keittio',
  MARKET: 'market',
  HESBURGER: 'hesburger',
}
type MonthlyInfoRootProps = {
  history: RouterHistory
  location: Location
  match: Match
}

class MonthlyInfoRoot extends React.PureComponent<MonthlyInfoRootProps> {
  getTabs = () => [
    {
      label: i18n.t('monthlyInfo.tab.manager'),
      value: TABS.MANAGER,
    },
    {
      label: i18n.t('monthlyInfo.tab.restaurant'),
      value: TABS.RESTAURANT,
    },
    {
      label: i18n.t('monthlyInfo.tab.kitchen'),
      value: TABS.KITCHEN,
    },
    {
      label: i18n.t('monthlyInfo.tab.market'),
      value: TABS.MARKET,
    },
    {
      label: i18n.t('monthlyInfo.tab.hesburger'),
      value: TABS.HESBURGER,
    },
  ]
  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[parts.length - 2] || TABS.MANAGER
  }
  onTabClick = (tab) => {
    const parts = this.props.location.pathname.split('/')
    const month = parts.length === 4 ? parts[3] : undefined
    const target = [this.getBasePath(), tab.value]
    this.props.history.push((month ? [...target, month] : target).join('/'))
  }
  getBasePath = () => this.props.location.pathname.split('/').slice(0, 2).join('/')

  render() {
    const { match } = this.props
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('monthlyInfo.title.page')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('monthlyInfo.title.page')}</Typography>
          <Switch>
            <Route path={`${match.path}/${TABS.MARKET}/:month`} component={MarketPage} />
            <Route exact path={`${match.path}/${TABS.MARKET}`} component={MarketPage} />
            <Route path={`${match.path}/${TABS.KITCHEN}/:month`} component={KitchenPage} />
            <Route exact path={`${match.path}/${TABS.KITCHEN}`} component={KitchenPage} />
            <Route path={`${match.path}/${TABS.RESTAURANT}/:month`} component={RestaurantPage} />
            <Route exact path={`${match.path}/${TABS.RESTAURANT}`} component={RestaurantPage} />
            <Route path={`${match.path}/${TABS.HESBURGER}/:month`} component={HesburgerPage} />
            <Route exact path={`${match.path}/${TABS.HESBURGER}`} component={HesburgerPage} />
            <Route path={`${match.path}/${TABS.MANAGER}/:month`} component={ManagerPage} />
            <Route exact path={`${match.path}/${TABS.MANAGER}`} component={ManagerPage} />
            <Redirect to={`${match.path}/${TABS.MANAGER}`} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(MonthlyInfoRoot)
